"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  Color: () => import_color.Color,
  MenuAction: () => import_menu.MenuAction,
  SplitView: () => import_split_view.SplitView,
  StackToolbar: () => import_StackToolbar.StackToolbar,
  ToolbarHost: () => import_toolbar.ToolbarHost,
  ToolbarItem: () => import_toolbar.ToolbarItem,
  ZoomTransitionAlignmentRectDetector: () => import_zoom.ZoomTransitionAlignmentRectDetector,
  ZoomTransitionEnabler: () => import_zoom.ZoomTransitionEnabler,
  ZoomTransitionSource: () => import_zoom.ZoomTransitionSource
});
module.exports = __toCommonJS(index_exports);
var import_StackToolbarImplementation = require("./StackToolbarImplementation");
var import_color = require("./color");
var import_zoom = require("./zoom");
var import_toolbar = require("./toolbar");
var import_menu = require("./menu");
var import_split_view = require("./split-view");
var import_StackToolbar = require("./stack-toolbar/StackToolbar");
(0, import_StackToolbarImplementation.registerNativeStackToolbar)();
//# sourceMappingURL=index.js.map
